import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import Feedback from './Feedback'
import Footer from './Footer'
import MediaGallery from './MediaGallery'
import Strategy777 from './Strategy777'
import TargetBeneficiaries from './TargetBeneficiaries'
import KeyFeatures from './KeyFeatures'
import OneStopPortal from './OneStopPortal'
import HeroStats from './HeroStats'
import HeroSection from './HeroSection'

const Home = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.scrollTo) {
            const id = location.state.scrollTo;
            // Clear location state to prevent scrolling again on navigation/refresh
            window.history.replaceState({}, document.title);

            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            } else {
                // Retry in case DOM is not fully ready
                const timer = setTimeout(() => {
                    const el = document.getElementById(id);
                    if (el) {
                        el.scrollIntoView({ behavior: "smooth" });
                    }
                }, 100);
                return () => clearTimeout(timer);
            }
        }
    }, [location]);

    return (
        <div>
            <Header />
            <HeroSection />
            <HeroStats />
            <div id="about">
                <OneStopPortal />
            </div>
            <div id="strategy">
                <Strategy777 />
            </div>
            <div id="beneficiaries">
                <TargetBeneficiaries />
            </div>
            <div id="gallery">
                <MediaGallery />
            </div>
            <div id="feedback">
                <Feedback />
            </div>
            <Footer />
        </div>
    )
}

export default Home
